<template>
  <BaseCard class="flex border-0">
    <div class="relative w-24 rounded-l-lg">
      <img
        v-if="cover"
        :srcset="cover.srcsets || ''"
        @load.once="onImageLoad"
        sizes="1px"
        :src="cover.url"
        class="rounded-l-lg object-cover w-full"
      />
      <div v-else class="rounded-l-lg bg-gray-400 absolute inset-0" />
    </div>
    <BaseCardBody class="flex-1">
      <div class="flex items-baseline -mr-4">
        <div class="flex-1 px-4">
          {{ productServiceUpgrade.name }}
        </div>
        <div class="flex-none px-4 font-medium">{{ productServiceUpgrade.price }}&euro;</div>
        <div class="flex-none px-4">
          <BaseButton primary @click="$emit('product-service-upgrade-edit')"> Edit </BaseButton>
          <BaseButton ghost class="ml-2" @click="$emit('product-service-upgrade-delete')">
            Delete
          </BaseButton>
        </div>
      </div>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { mapState } from 'vuex';
import mediableMixin from '@/mixins/mediableMixin';

export default {
  name: 'UpgradeCard',
  mixins: [mediableMixin],
  props: {
    productServiceUpgrade: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', ['products']),
    service() {
      return this.products.byId[this.productServiceUpgrade.serviceUuid] || null;
    },
    cover() {
      const { media = [] } = this.service || {};
      return media.find((item) => item.collection === 'images') || null;
    },
  },
};
</script>
